import { all, fork, put, takeLatest, select, takeEvery } from 'redux-saga/effects';
import { get } from 'lodash';
import { BOOT, bootFinished } from './';
import { redirect } from 'redux-first-router';
import { selectRoutesMap, selectRouteType } from '../routing';
import { fetchUserInfo, FETCH_USER_SUCCESS } from '../auth';
import { initializeFCM } from '../fcm';

import { RealtimeEventType } from '../../../constant/realtimeEvent';

function* watchAppBoot() {
  yield takeLatest(BOOT, function* () {
    const { location } = yield select();
    const routesMap = yield select(selectRoutesMap);
    const routeType = yield select(selectRouteType);
    const currentRoute = routesMap[routeType];
    if (!currentRoute.requiresAuth) {
      yield put(bootFinished());
      yield put(
        redirect({
          type: location.type,
          payload: location.payload,
          query: location.query,
        })
      );
      const token = get(location, 'query.token', '');
      yield put(fetchUserInfo(token));
    } else {
      const token = get(location, 'query.token', '');
      yield put(fetchUserInfo(token));
    }
  });
}

function* watchUserBalance() {
  // listen to reload user balance
  yield takeEvery([RealtimeEventType.POINTS_EARNED, RealtimeEventType.POINTS_SPENT], function* () {
    yield put(fetchUserInfo('', false));
  });
}

function* watchUserLogin() {
  // Initialize FCM after user successfully logs in
  yield takeLatest(FETCH_USER_SUCCESS, function* () {
    // Only initialize FCM if browser supports it
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      // VAPID key is automatically read from REACT_APP_FCM_VAPID_KEY env variable
      yield put(initializeFCM());
    }
  });
}

export default function* auth() {
  yield all([fork(watchAppBoot)]);
  yield all([fork(watchUserBalance)]);
  yield all([fork(watchUserLogin)]);
}
